import { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface FilterBarProps {
  children: ReactNode
  className?: string
}

export function FilterBar({ children, className }: FilterBarProps) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-nowrap gap-2 md:gap-3 overflow-x-auto overscroll-x-contain pb-2 scrollbar-hide",
        className)}
    >
      {children}
    </div>
  )
}
